import React from 'react';
import { Modal, Alert, Tag } from 'antd';

const REPAIR_MAP = (() => {
  const FFD = '\uFFFD';
  const P = (pieces) => pieces.join(FFD);
  const R = (s, flags) => new RegExp(s, flags);
  const pairs = [
    [P(['D','tect']),       'Détect'],
    [P(['d','tect']),       'détect'],
    [P(['monophas']),       'monophasé'],
    [P(['triphas']),        'triphasé'],
    [P(['r','f','rence']),  'référence'],
    [P(['R','f','rence']),  'Référence'],
    [P(['d','crit']),       'décrit'],
    [P(['','quip']),        'équip'],
    [P(['','tabli']),       'établi'],
    [P(['','tabl']),        'établ'],
    [P(['s','curit']),      'sécurité'],
    [P(['S','curit']),      'Sécurité'],
    [P(['gr','ce']),        'grâce'],
    [P(['','nergie']),      'énergie'],
    [P(['','lectrique']),   'électrique'],
    [P(['','lectron']),     'électron'],
    [P(['fum','e']),        'fumée'],
    [P(['Fum','e']),        'Fumée'],
    [P(['qualit']),         'qualité'],
    [P(['autorit']),        'autorité'],
    [P(['optiqu','e']),     'optique'],
    [P(['Optiqu','e']),     'Optique'],
    [P(['ponctuel']),       'ponctuel'],
    [P(['Ponctuel']),       'Ponctuel'],
    [P(['Gamme']),          'Gamme'],
    [P(['Onduleur']),       'Onduleur'],
    [P(['onduleur']),       'onduleur'],
    [P(['Adressable']),     'Adressable'],
    [P(['adressable']),     'adressable']
  ];
  return pairs.map(([p, r]) => [R(p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), r]);
})();

// 🔧 Helper: nettoyer caractères U+FFFD + repair intelligente (mots les plus courants DomoElec)
const cleanFFFD = (s) => {
  if (s == null) return '';
  let out = String(s);
  if (/\uFFFD/.test(out)) {
    for (const [rx, replacement] of REPAIR_MAP) {
      out = out.replace(rx, replacement);
    }
  }
  out = out.replace(/\uFFFD{2,}/g, ' · ');
  out = out.replace(/\uFFFD/g, '');
  out = out.replace(/\s+/g, ' ').trim();
  return out;
};

const ImportResultModal = ({ open, onClose, result }) => {
  if (!result) return null;

  const { imported = 0, errors = 0, details = [], message = '' } = result;
  const errorDetails = (details || []).filter(d => d && (typeof d.error === 'string' ? d.error.length > 0 : !!d.error));
  const successDetails = (details || []).filter(d => d && !(typeof d.error === 'string' ? d.error.length > 0 : !!d.error) && !(d.status && String(d.status).toLowerCase().includes('warn')));
  const warningDetails = (details || []).filter(d => d && d.status && String(d.status).toLowerCase().includes('warn') && !(typeof d.error === 'string' ? d.error.length > 0 : !!d.error));

  return (
    <Modal
      title="Résultat de l'import"
      open={open}
      onCancel={onClose}
      onOk={onClose}
      okText="Fermer"
      width={720}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      {message && (
        <Alert
          type={errors > 0 ? 'warning' : 'success'}
          showIcon
          style={{ marginBottom: 16 }}
          title={cleanFFFD(message)}
        />
      )}
      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: 16, flex: 1, textAlign: 'center' }}>
          <div style={{ color: '#389e0d', fontWeight: 600, marginBottom: 4 }}>Importés ✅</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#237804' }}>{imported}</div>
        </div>
        <div style={{ background: errors > 0 ? '#fff1f0' : '#fafafa', border: `1px solid ${errors > 0 ? '#ffa39e' : '#d9d9d9'}`, borderRadius: 8, padding: 16, flex: 1, textAlign: 'center' }}>
          <div style={{ color: errors > 0 ? '#cf1322' : '#595959', fontWeight: 600, marginBottom: 4 }}>Erreurs ❌</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: errors > 0 ? '#a8071a' : '#8c8c8c' }}>{errors}</div>
        </div>
      </div>

      {errors > 0 && (
        <button
          onClick={typeof result?.downloadErrorsCsv === 'function' ? result.downloadErrorsCsv : () => {
            if (!errorDetails || errorDetails.length === 0) return;
            const rows = [['Ligne', 'Produit', 'Erreur']];
            errorDetails.forEach((d) => rows.push([(d.index ?? '') + 2, d.product || '', d.error || '']));
            const csv = rows.map(r => r.map(cell => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(',')).join('\n');
            const BOM = '\uFEFF';
            const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a'); a.href = url; a.download = `erreurs-import-${Date.now()}.csv`; document.body.appendChild(a); a.click();
            setTimeout(() => { URL.revokeObjectURL(url); document.body.removeChild(a); }, 100);
          }}
          style={{
            background: '#1677ff', color: '#fff', border: 0, borderRadius: 6,
            padding: '8px 14px', cursor: 'pointer', marginBottom: 14, fontWeight: 600
          }}
        >
          📥 Télécharger le CSV des erreurs ({errorDetails.length})
        </button>
      )}

      <div style={{ maxHeight: 360, overflow: 'auto', border: '1px solid #f0f0f0', borderRadius: 6, padding: 10, background: '#fafafa' }}>
        {/* ==== LISTE ERREURS ==== */}
        {errorDetails.length > 0 && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontWeight: 700, color: '#a8071a', marginBottom: 6 }}>⚠️ Détails des erreurs ({errorDetails.length})</div>
            {errorDetails.slice(0, 50).map((d, idx) => (
              <div key={`e${idx}`} style={{ background: '#fff1f0', borderLeft: '3px solid #cf1322', padding: '6px 8px', marginBottom: 4, borderRadius: 4, fontSize: 13 }}>
                <Tag color="red" style={{ marginRight: 6 }}>Ligne {(d.index ?? '') + 2}</Tag>
                <strong style={{ marginRight: 6 }}>{cleanFFFD(d.product) || 'Inconnu'}</strong>
                <div style={{ color: '#a8071a', marginTop: 2 }}>{cleanFFFD(d.error)}</div>
              </div>
            ))}
            {errorDetails.length > 50 && (
              <div style={{ color: '#8c8c8c', fontSize: 12, marginTop: 4 }}>... {errorDetails.length - 50} erreurs supplémentaires — téléchargez le CSV.</div>
            )}
          </div>
        )}

        {/* ==== LISTE SUCCESSES ==== */}
        {successDetails.length > 0 && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontWeight: 700, color: '#237804', marginBottom: 6 }}>✅ Produits importés ({successDetails.length})</div>
            {successDetails.slice(0, 30).map((d, idx) => (
              <div key={`s${idx}`} style={{ background: '#f6ffed', borderLeft: '3px solid #389e0d', padding: '6px 8px', marginBottom: 4, borderRadius: 4, fontSize: 13 }}>
                <Tag color="green" style={{ marginRight: 6 }}>Ligne {(d.index ?? '') + 2}</Tag>
                <strong>{cleanFFFD(d.product) || 'Inconnu'}</strong>
              </div>
            ))}
            {successDetails.length > 30 && (
              <div style={{ color: '#8c8c8c', fontSize: 12, marginTop: 4 }}>... {successDetails.length - 30} succès supplémentaires.</div>
            )}
          </div>
        )}

        {/* ==== WARNING / avertissements ==== */}
        {warningDetails.length > 0 && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontWeight: 700, color: '#d46b08', marginBottom: 6 }}>⚠️ Avertissements ({warningDetails.length})</div>
            {warningDetails.slice(0, 20).map((d, idx) => (
              <div key={`w${idx}`} style={{ background: '#fff7e6', borderLeft: '3px solid #ffa940', padding: '6px 8px', marginBottom: 4, borderRadius: 4, fontSize: 13 }}>
                <Tag color="orange" style={{ marginRight: 6 }}>Ligne {(d.index ?? '') + 2}</Tag>
                <strong style={{ marginRight: 6 }}>{cleanFFFD(d.product) || 'Inconnu'}</strong>
                <div style={{ color: '#d46b08', marginTop: 2 }}>{cleanFFFD(d.message || d.status || '')}</div>
              </div>
            ))}
          </div>
        )}

        {/* ==== AUCUN DÉTAIL DISPO ==== */}
        {errorDetails.length === 0 && successDetails.length === 0 && warningDetails.length === 0 && (
          <div style={{ color: '#8c8c8c', fontSize: 13, textAlign: 'center', padding: '12px 0' }}>
            ℹ️ Aucun détail renvoyé par le serveur pour cette importation.
            {errors > 0 && <> Vérifiez la console backend (PowerShell du serveur) pour voir les erreurs brutes.</>}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ImportResultModal;


